import { type TemplateValue } from '../../../../../models/TemplateLibrary'

const rank = (template: TemplateValue, currentTemplateId?: string) => (template.id === currentTemplateId ? 0 : template.scope === 'system' ? 1 : 2)

export const currentFirst = (templates: TemplateValue[], currentTemplateId?: string): TemplateValue[] =>
  [...templates].sort((a, b) => rank(a, currentTemplateId) - rank(b, currentTemplateId))
